import { NuqsAdapter } from 'nuqs/adapters/react'
import { VndlyTimesheetProvider } from './context/VndlyTimesheetProvider'
import { VndlyTimesheetMain } from './components/VndlyTimesheetMain'

export function VndlyTimesheetPage() {
  return (
    <NuqsAdapter>
      <VndlyTimesheetProvider>
        <VndlyTimesheetMain />
      </VndlyTimesheetProvider>
    </NuqsAdapter>
  )
}
